import React from 'react';
import cookie from 'react-cookies';
import { decrypt } from '../utils/crypto';
import Config from '@/config/config';
const { cookie: { expires } } = Config;

// 获取用户信息
export function get_user_info_ajax(fn) {

  return ((dispatch, getState) => {
    fn && fn();


    // React.$request('/user/current').then((res) => {
    //   const userInfo = res.data;
    //   if (userInfo.status_code) {
    //     console.log('获取信息失败！');
    //   } else {
    //     let _curWechatUserInfo = {
    //       userInfo: {
    //         ...userInfo,
    //       }
    //     };
    //     cookie.save('openid', _curWechatUserInfo.userInfo.offiaccount_openid, {
    //       expires,
    //     });
    //     cookie.save('unionid', _curWechatUserInfo.userInfo.unionid, {
    //       expires,
    //     });
    //     console.log('_curWechatUserInfo', _curWechatUserInfo)
    //     if (userInfo.profile) {
    //       _curWechatUserInfo.userInfo.profile = {
    //         ...userInfo.profile,
    //         first_name: decrypt(userInfo.profile.first_name),
    //         last_name: decrypt(userInfo.profile.last_name),
    //         company: decrypt(userInfo.profile.company),
    //         tel: decrypt(userInfo.profile.tel),
    //         email: decrypt(userInfo.profile.email),
    //         // job: decrypt(userInfo.profile.job),
    //         // country: decrypt(userInfo.profile.country),
    //       };
    //     };
    //     dispatch(save(_curWechatUserInfo));
    //     fn && fn();
    //   };
    // }).catch(() => {
    //   fn && fn();
    // });
  })
};

// 保存数据
export function save(data) {
  return { type: "save", payload: { ...data } };
}
